import { QueryClient } from "@/api/zustandQuery";
import { dataClient } from "@/api/dataClient";

export const queryClient = new QueryClient(undefined, dataClient);
